import { requestsConstants } from '../constants/requestsConstants';

const initialState = {
    loading : false,
    items: [],
    item: null, 
    error : null
};

const requestsReducer = (state = initialState, action) => {
    switch (action.type) {
        case requestsConstants.LIST_SUCCESS :
            return {
                ...state,
                loading : false,
                items : action.items
            }
        case requestsConstants.ITEM_REQUEST :
            return {
                ...state,
                loading : true,
                item : { ...action.cache, evolutions: [] }
            }
        case requestsConstants.ITEM_SUCCESS :
            return {
                ...state,
                loading : false,
                item : { ...action.item, evolutions: action.evolutions }
            }
        case requestsConstants.NOTIFICATION : 
            console.log('ITEM', action.item)
            const _items = state.items.map(i => {
                if (i.id == action.item.id) {
                    console.log('changing reg');
                    console.log({ ...i, ...action.item })
                    return { ...i, ...action.item }
                }
                return i;
            })
            if (state.item?.id == action.item.id) {
                console.log('UPDATE ITEM')
                state.item = { ...state.item, ...action.item }
            }
            return {
                ...state,
                items : _items
            }
        case requestsConstants.RESET :
            return {
                ...initialState
            }
        default:
            return state
    }
}

export default requestsReducer